import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/matrix`;
const KEY = "matrix_token";

export const matrixApi = axios.create({ baseURL: API });

matrixApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const matrixAuth = {
  token: () => localStorage.getItem(KEY),
  save: (t) => localStorage.setItem(KEY, t),
  clear: () => localStorage.removeItem(KEY),
};

export const matrixError = (e, fallback = "Algo salió mal") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "").join(" ") || fallback;
  return fallback;
};
